import React, { FC, memo } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@material-ui/core';
import { copyToClipboard } from 'src/utils';
import { FileCopy } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  qrcodeImage: string;
  link: string;
  ecommLink?: string;
  onClose: () => void;
  open: boolean;
}

const component: FC<Props> = ({
  qrcodeImage,
  link,
  ecommLink,
  onClose,
  open
}) => {
  const LinkRow = ({ label, url }: { label: string; url: string }) => (
    <Box display="flex" flexDirection="column" mb={2}>
      <Typography variant="body2">{label} </Typography>

      <Box display="flex" alignItems="center">
        <Typography variant="body1" style={{ wordBreak: 'break-all' }}>
          {url}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="quotation-link-dialog"
      open={open}
    >
      <DialogTitle id="quotation-link-dialog" style={{ textAlign: 'center' }}>
        <Typography variant="h4">Quotation Link</Typography>
        <IconButton
          aria-label="close"
          style={{ position: 'absolute', right: 5, top: 2 }}
          color="secondary"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ padding: '0px 24px 16px' }}>
        <Box style={{ textAlign: 'center' }}>
          <img src={qrcodeImage} alt="QR Code" />
        </Box>

        <Table>
          <TableBody>
            <TableRow>
              <TableCell style={{ borderBottom: 'none' }}>
                <LinkRow label="Add Quotation to Cart:" url={link} />
              </TableCell>

              <TableCell style={{ borderBottom: 'none', textAlign: 'center' }}>
                <IconButton size="small" onClick={() => copyToClipboard(link)}>
                  <FileCopy />
                </IconButton>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ borderBottom: 'none' }}>
                <LinkRow label="Show PC Worth Quotation Page:" url={ecommLink || ''} />
              </TableCell>
              <TableCell style={{ borderBottom: 'none', textAlign: 'center' }}>
                <IconButton
                  size="small"
                  onClick={() => copyToClipboard(ecommLink || '')}
                >
                  <FileCopy />
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Typography
          color="error"
          variant="h4"
          style={{
            textAlign: 'center',
            marginBottom: '1em'
          }}
        >
          Always make sure customer has pcworth.com account and that they get
          the proper items from their cart
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export const QuotationLinkDialog = memo(component);
